import { render, staticRenderFns } from "./RecordsDetail.vue?vue&type=template&id=79846bea&scoped=true"
import script from "./RecordsDetail.vue?vue&type=script&lang=js"
export * from "./RecordsDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordsDetail.vue?vue&type=style&index=0&id=79846bea&prod&lang=less&scoped=true"
import style1 from "./RecordsDetail.vue?vue&type=style&index=1&id=79846bea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79846bea",
  null
  
)

export default component.exports